module.exports = __webpack_public_path__ + "img/d20190823_4.d8f0cbf6.jpg";